<template>
    <div :id="id">
        <span class="rating-stars" :title="__('Rating') + ': ' + internal_value + '/' + max_rating">
            <span class="rating-value" :style="'width: ' + percentage + '%'"></span>
        </span>
        <span v-if="showVoterCount" class="rating-count ml-2">{{voterCount}} {{ voterCount === 1 ? __('Rating') : __('Ratings') }}</span>
    </div>
</template>

<script>
    import trans from '../mixins/trans';

    export default {

        mixins: [
            trans
        ],

        props: {
            'id': String,
            'value': null,
            'voterCount': [String, Number],
            'showVoterCount': Boolean
        },

        data() {
            return {
                step: 0.5,
                max_rating: 5
            };
        },

        methods: {
            round(value, decimalPlaces = 2) {
                value = Number(value + "e" + decimalPlaces);
                return Number(Math.round(value)  + "e" + -decimalPlaces);
            },

            roundToStep(value) {
                let inv = 1.0 / this.step;
                return Math.round(value * inv) / inv;
            },
        },

        computed: {
            internal_value() {
                let result = !isNaN(parseFloat(this.value)) ? parseFloat(this.value) : 0.0;
                return this.round(result);
            },

            percentage() {
                if (this.internal_value > 0.0) {
                    return this.roundToStep(this.internal_value) / this.max_rating * 100;
                }
                return 0.0;
            }
        }

    }
</script>